<script setup>
import { ref, onMounted } from 'vue'
// 1. 引入 canvas-confetti
import confetti from 'canvas-confetti';
// 2. 引入 EmailJS
import emailjs from '@emailjs/browser';
import dangao from '@/assets/dangao.png'
const wishText = ref('')
const isWished = ref(false)
const showModal = ref(false)
// 新增：控制流星雨的状态
const showMeteors = ref(false)
// 新增：存放流星样式的数组
const meteors = ref([])

// 邮件相关状态
const recipientEmail = ref('3473557129@qq.com') // 默认收件人邮箱
const emailSubject = ref('生日愿望') // 邮件主题
const isSendingEmail = ref(false) // 邮件发送状态
const emailSendResult = ref(null) // 邮件发送结果: null | 'success' | 'error'

// 初始化生成流星数据 (生成 30 颗)
const initMeteors = () => {
  const count = 30
  const newMeteors = []
  for (let i = 0; i < count; i++) {
    newMeteors.push({
      // 随机位置：从屏幕宽度的 -20% 到 120% 之间随机分布
      left: Math.floor(Math.random() * 140) - 20 + '%',
      // 随机延迟：0 到 5秒之间，让流星错落有致
      delay: (Math.random() * 5).toFixed(2) + 's',
      // 随机速度：2秒 到 5秒之间
      duration: (Math.random() * 3 + 2).toFixed(2) + 's'
    })
  }
  meteors.value = newMeteors
}

// 定义烟花颜色盘 (契合主题的梦幻色 + 一些亮色)
const fireworkColors = ['#ff9a9e', '#a1c4fd', '#fecfef', '#ffe58f', '#ffffff', '#c2e9fb'];

// --- 烟花发射核心函数 ---
// 封装一个通用的发射函数，模拟一次烟花绽放
function fire(particleRatio, opts) {
  // 基础参数配置，让它看起来像烟花而非彩带
  const defaults = {
    colors: fireworkColors,
    origin: { y: 0.7 }, // 从屏幕下方70%的位置发射
    spread: 120,        // 爆炸扩散范围
    startVelocity: 45,  // 发射初速度
    gravity: 1.2,       // 重力，让粒子下落更自然
    ticks: 150,         // 粒子存活时间 (帧数)
    decay: 0.92,        // 粒子速度衰减系数 (越大消失越慢)
    scalar: 1.2,        // 粒子大小缩放
    zIndex: 999,        // 保证在最上层
    disableForReducedMotion: true // 照顾对动效敏感的用户
  };

  confetti(
      Object.assign({}, defaults, opts, {
        // 根据比例计算粒子数量 (基础值 * 比例)
        particleCount: Math.floor(200 * particleRatio)
      })
  );
}

// --- 执行多轮烟花表演 ---
const launchFireworksShow = () => {
  // 第1发：屏幕中间偏下，小范围
  fire(0.25, {
    spread: 60,
    startVelocity: 55,
    origin: { x: 0.5, y: 0.8 }
  });

  // 第2发：左侧，延时200ms
  setTimeout(() => {
    fire(0.3, {
      spread: 80,
      origin: { x: 0.3, y: 0.75 }
    });
  }, 200);

  // 第3发：右侧，延时400ms
  setTimeout(() => {
    fire(0.3, {
      spread: 80,
      origin: { x: 0.7, y: 0.75 }
    });
  }, 400);

  // 第4发：中间大爆发，延时700ms
  setTimeout(() => {
    fire(0.5, {
      spread: 180,    // 广角爆发
      startVelocity: 60,
      decay: 0.90,
      particleCount: 250, // 更多粒子
      origin: { x: 0.5, y: 0.65 }
    });
    // (可选) 这里可以尝试播放一个烟花音效
    // playFireworkSound();
  }, 700);
}


// --- 发送邮件函数 ---
const sendEmail = async () => {
  try {
    isSendingEmail.value = true
    emailSendResult.value = null

    const result = await emailjs.send(
      'service_kmouoni', // Service ID
      'template_nvmp7lb', // Template ID
      {
        to_email: recipientEmail.value,
        name: emailSubject.value,
        message: wishText.value
      }
    )

    console.log('邮件发送成功:', result)
    emailSendResult.value = 'success'
    return true
  } catch (error) {
    console.error('邮件发送失败:', error)
    emailSendResult.value = 'error'
    return false
  } finally {
    isSendingEmail.value = false
  }
}

// --- 提交愿望的主交互 ---
const makeWish = async () => {
  if (!wishText.value.trim()) return

  // 1. 切换UI状态 (蜡烛熄灭，卡片变小)
  isWished.value = true

  // 2. 开始烟花表演
  launchFireworksShow();

  // 3. 开启流星雨
  showMeteors.value = true

  // 4. 发送邮件（异步执行，不阻塞UI）
  sendEmail()

  // 5. 延时弹出成功窗口 (时间比之前稍微长一点，让烟花放完)
  setTimeout(() => {
    showModal.value = true
  }, 2000)
}

onMounted(() => {
  initMeteors()
  // 初始化 EmailJS
  emailjs.init('vt9_ML202U75P2_gp')
})
</script>

<template>
  <div class="wish-section">
    <div class="cloud cloud-1">☁️</div>
    <div class="cloud cloud-2">☁️</div>
    <div class="cloud cloud-3">☁️</div>

    <div class="meteor-shower" v-if="showMeteors">
      <div
          v-for="(star, index) in meteors"
          :key="index"
          class="meteor"
          :style="{
          left: star.left,
          animationDelay: star.delay,
          animationDuration: star.duration
        }"
      ></div>
    </div>

    <div class="wish-container">
      <div class="header">
        <h1>许愿</h1>
        <p>闭上眼睛，一个心愿吧 ✨</p>
        <p>愿岁岁常欢愉，年年皆胜意</p>
      </div>

      <div class="wish-card" :class="{ 'sending': isWished }">

        <div class="cake-visual">
          <div class="cake-img-placeholder">
            <img :src="dangao" style="width: 120px;">
            <div class="candle-glow" v-if="!isWished"></div>
          </div>
        </div>

        <div class="input-area" v-if="!isWished">
          <textarea
              v-model="wishText"
              placeholder="在这里写下你的生日愿望..."
              maxlength="100"
          ></textarea>
        </div>

        <div class="wished-content" v-else>
          <div class="star-dust">✨</div>
          <p>愿望已收到</p>
          <p class="sub-text">正在飞往星星的路上...</p>
        </div>

        <button
            class="wish-btn"
            @click="makeWish"
            :disabled="isWished || !wishText || isSendingEmail"
        >
          {{
            isSendingEmail ? '发送邮件中...' :
            isWished ? '愿望封存中...' :
            '许 愿 💫'
          }}
        </button>
      </div>
    </div>

    <div class="modal-overlay" v-if="showModal">
      <div class="modal-content">
        <div class="modal-icon">💌</div>
        <h3>愿望已确认!</h3>
        <p>宝，不管愿望是什么，<br>我都会陪你一起实现它 ❤️</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* CSS 样式与之前保持完全一致，无需修改 */
/* ... (粘贴之前的CSS代码) ... */
.wish-section {
  min-height: 100vh;
  background: linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.cloud {
  position: absolute;
  color: rgba(255, 255, 255, 0.8);
  font-size: 40px;
  filter: blur(2px);
  z-index: 0;
  animation: floatCloud 20s infinite linear;
}
.cloud-1 { top: 10%; left: -10%; animation-duration: 25s; }
.cloud-2 { top: 40%; left: -20%; animation-duration: 35s; font-size: 60px; animation-delay: 5s; }
.cloud-3 { top: 70%; left: -15%; animation-duration: 28s; animation-delay: 2s; }

@keyframes floatCloud {
  0% { transform: translateX(0); }
  100% { transform: translateX(120vw); }
}

.wish-container {
  width: 100%;
  max-width: 360px;
  z-index: 10;
  text-align: center;
  position: relative;
}

.header h1 {
  color: #fff;
  font-size: 28px;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.header p {
  color: #fff;
  opacity: 0.9;
  font-size: 14px;
  margin-bottom: 24px;
}

.wish-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 24px;
  padding: 30px 24px;
  box-shadow: 0 10px 30px rgba(161, 196, 253, 0.4);
  transition: all 0.5s ease;
  position: relative;
  overflow: hidden;
}

.wish-card.sending {
  transform: translateY(-20px) scale(0.95);
  opacity: 0.9;
  filter: blur(0.5px);
}

.cake-visual {
  margin-bottom: 20px;
  position: relative;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.email-config {
  margin-bottom: 20px;
}

.email-field {
  margin-bottom: 12px;
  text-align: left;
}

.email-field label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  font-weight: 500;
}

.email-field input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e0eaff;
  background: #f8fbff;
  border-radius: 12px;
  font-size: 14px;
  color: #555;
  outline: none;
  transition: all 0.3s;
  box-sizing: border-box;
}

.email-field input:focus {
  border-color: #a1c4fd;
  background: #fff;
}

.email-field input::placeholder {
  color: #bcccdc;
}
.cake-img-placeholder {
  font-size: 80px;
  position: relative;
  animation: bounce 3s infinite ease-in-out;
}
.candle-glow {
  position: absolute;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  width: 10px;
  height: 10px;
  background: #ffdb4d;
  border-radius: 50%;
  box-shadow: 0 0 15px #ffdb4d, 0 0 30px #ff9a9e;
  animation: flicker 1s infinite alternate;
}

.input-area textarea {
  width: 100%;
  height: 120px;
  border: 2px solid #e0eaff;
  background: #f8fbff;
  border-radius: 16px;
  padding: 16px;
  font-size: 15px;
  color: #555;
  resize: none;
  outline: none;
  transition: all 0.3s;
  box-sizing: border-box;
}
.input-area textarea:focus {
  border-color: #a1c4fd;
  background: #fff;
}
.input-area textarea::placeholder {
  color: #bcccdc;
}

.wish-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(90deg, #ff9a9e 0%, #fecfef 99%);
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 20px;
  box-shadow: 0 4px 15px rgba(255, 154, 158, 0.4);
  transition: transform 0.2s;
}
.wish-btn:active {
  transform: scale(0.98);
}
.wish-btn:disabled {
  background: linear-gradient(90deg, rgba(255, 154, 158, 0.5) 0%, rgba(254, 207, 239, 0.5) 99%);
  box-shadow: 0 2px 8px rgba(255, 154, 158, 0.2);
  cursor: default;
  opacity: 0.7;
}

.wished-content {
  padding: 40px 0;
  animation: fadeIn 1s;
}
.star-dust {
  font-size: 40px;
  margin-bottom: 10px;
  display: inline-block;
  animation: spin 3s infinite linear;
}
.wished-content p {
  color: #555;
  font-size: 18px;
  font-weight: bold;
}
.wished-content .sub-text {
  font-size: 14px;
  color: #999;
  font-weight: normal;
  margin-top: 8px;
}

.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(4px);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s;
}
.modal-content {
  background: #fff;
  width: 80%;
  max-width: 300px;
  padding: 30px;
  border-radius: 20px;
  text-align: center;
  animation: popUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.modal-icon { font-size: 40px; margin-bottom: 15px; }
.modal-content h3 { color: #333; margin-bottom: 10px; }
.modal-content p { color: #666; font-size: 14px; line-height: 1.6; margin-bottom: 20px; }

.email-status {
  margin-top: 15px;
  padding: 10px;
  border-radius: 8px;
  font-size: 12px;
}

.email-success {
  background: rgba(76, 175, 80, 0.1);
  border: 1px solid #4CAF50;
  color: #4CAF50;
}

.email-error {
  background: rgba(244, 67, 54, 0.1);
  border: 1px solid #F44336;
  color: #F44336;
}

.email-status span {
  display: flex;
  align-items: center;
  justify-content: center;
}
.close-btn {
  background: #a1c4fd;
  color: #fff;
  border: none;
  padding: 10px 24px;
  border-radius: 30px;
  font-size: 14px;
  cursor: pointer;
}

@keyframes flicker {
  0% { opacity: 1; transform: translateX(-50%) scale(1); }
  100% { opacity: 0.8; transform: translateX(-50%) scale(1.1); }
}
@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}
@keyframes spin { 100% { transform: rotate(360deg); } }
@keyframes popUp {
  0% { opacity: 0; transform: scale(0.5); }
  100% { opacity: 1; transform: scale(1); }
}
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

/* --- 流星雨容器 --- */
.meteor-shower {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1; /* 在云朵之上，但建议在许愿卡片之下 */
  pointer-events: none; /* 关键：让点击穿透，不影响操作 */
}

/* --- 单个流星样式 --- */
.meteor {
  position: absolute;
  top: -100px; /* 初始位置在屏幕外 */
  width: 2px;
  height: 100px; /* 流星的长度 */
  /* 漂亮的渐变尾巴：透明 -> 白色 -> 透明 */
  background: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1), rgba(255,255,255,0));
  /* 旋转 45 度，形成斜着落下的效果 */
  transform: rotate(-45deg);
  /* 增加一点发光效果 */
  box-shadow: 0 0 10px #fff, 0 0 20px #fff;
  /* 应用动画 */
  animation-name: shower;
  animation-timing-function: linear;
  animation-iteration-count: infinite; /* 无限循环，一直下 */
  opacity: 0;
}

/* 加上一个小圆头，让流星更真实 */
.meteor::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 15px #fff;
}

/* --- 下落动画 --- */
@keyframes shower {
  0% {
    transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  10% {
    opacity: 1; /* 刚出现时最亮 */
  }
  100% {
    /* 这里的位移决定了流星划过的距离 */
    transform: rotate(-45deg) translate(-500px, 100vh);
    opacity: 0;
  }
}
</style>
